import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import i18n from "i18next";
export type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { type RootState } from "app/store";
import { selectConfig } from "slices/explorer";

const rawBaseQuery = fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: (headers, { getState }) => {
        const {
            auth: { accessToken },
        } = getState() as RootState;

        if (accessToken) {
            headers.set("authorization", `Bearer ${accessToken}`);

            if (!headers.has("Accept-Language")) {
                headers.set("Accept-Language", i18n.language);
            }
        }

        return headers;
    },
});

export function getDataV2DynamicBaseQuery(suffix = "") {
    const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
        args,
        api,
        extraOptions,
    ) => {
        const baseUrl = selectConfig(api.getState() as RootState).dataV2ServerUrl + suffix;
        if (!baseUrl) {
            return {
                error: {
                    status: 400,
                    statusText: "Bad Request",
                    data: "data-v2 URL is not defined",
                },
            };
        }
        const urlEnd = typeof args === "string" ? args : args.url;
        const adjustedUrl = `${baseUrl}${urlEnd}`;
        const adjustedArgs = typeof args === "string" ? adjustedUrl : { ...args, url: adjustedUrl };

        return rawBaseQuery(adjustedArgs, api, extraOptions);
    };

    return dynamicBaseQuery;
}

export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
    return typeof error === "object" && error !== null && "status" in error;
}
